import { useEffect, useState } from "react";
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import api from "@/lib/api";

function ctaLabel(prog) {
  if (!prog || prog.doneCount === 0) return "Start the path →";
  if (prog.doneCount >= prog.moduleCount) return "Review the path →";
  return `Continue — ${prog.doneCount} of ${prog.moduleCount} done →`;
}

export default function ProductHome() {
  const { pid } = useParams();
  const { setCrumbs } = useOutletContext();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [progress, setProgress] = useState({});

  useEffect(() => {
    let active = true;
    Promise.all([api.get(`/catalog/${pid}`), api.get(`/progress/${pid}`)])
      .then(([p, pr]) => {
        if (!active) return;
        setProduct(p.data);
        setProgress(pr.data.roles);
        setCrumbs([{ label: p.data.name, to: `/${pid}` }]);
      })
      .catch(() => navigate("/", { replace: true }));
    return () => { active = false; };
  }, [pid, navigate, setCrumbs]);

  if (!product) return <div className="loading">Loading…</div>;

  return (
    <section className="page" data-testid="product-home">
      <div className="container">
        <div className="eyebrow-accent" style={{ marginBottom: "16px" }}>{product.tag} · Certification paths</div>
        <h1 className="page-title" style={{ maxWidth: "760px" }}>{product.headline}</h1>
        <p className="page-sub">{product.sub}</p>

        <div className="grid-roles" data-testid="role-grid">
          {product.roles.map((r) => {
            const prog = progress[r.id];
            const pct = prog && prog.moduleCount ? Math.round((prog.doneCount / prog.moduleCount) * 100) : 0;
            return (
              <button key={r.id} className="rcard" onClick={() => navigate(`/${pid}/${r.id}`)} data-testid={`role-card-${r.id}`}>
                <div className="eyebrow">{r.kicker}</div>
                <div className="rcard__name">{r.name}</div>
                <p className="rcard__blurb">{r.blurb}</p>
                <div className="rcard__chips">
                  <span className="chip chip--neutral">{r.hours}</span>
                  <span className="chip chip--neutral">{r.moduleCount} modules</span>
                  <span className="chip chip--essential">{r.essentialCount} essential</span>
                </div>
                <div className="rcard__foot">
                  <div className="progress" aria-hidden="true">
                    <div className="progress__fill" style={{ width: `${pct}%` }} />
                  </div>
                  <div className="rcard__cta" data-testid={`role-cta-${r.id}`}>{ctaLabel(prog)}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
